import React from 'react';

import { Outlet } from 'react-router-dom';

import { CustomerHeader } from 'components';
import SessionPopup from 'components/SessionPopup/SessionPopup';

/**
 * Layout route for the logged-in customer area. Renders CustomerHeader once
 * and an <Outlet /> for whichever child route matched, instead of every
 * screen importing and rendering the header itself.
 *
 * Mounted as a wrapping <Route> with no `path` in CustomerRoutes — children
 * nested under it inherit this layout automatically. Routes that should NOT
 * show the header (sign-in, sign-up flow, onboarding, forgot-password, etc.)
 * stay as siblings outside this wrapper.
 *
 * CustomerHeader pins itself (position: fixed) and renders its own spacer
 * on non-hero pages — a sticky wrapper here only stayed pinned for the
 * first screen, since html/body/#root are height:100%. This is the actual
 * header shown on every customer-area page — AppWrapper also has its own
 * optional `showHeader`/<Header> (from `containers`), but that's a
 * different, unrelated component.
 *
 * SessionPopup ("Download the app") also lives here, once, so its
 * signed-out timer keeps running across every page under this layout.
 */
const CustomerLayout = () => (
  <>
    <CustomerHeader />
    <Outlet />
    <SessionPopup />
  </>
);

export default CustomerLayout;